<template>
  <div>
    <header class="section privacy-header">
      <div class="container">
        <div class="columns header">
          <div class="column is-full has-text-centered">
            <h1 class="title is-1">Terms and Conditions</h1>
            <p class="subtitle has-text-weight-medium">
              Last updated: August 17, 2020
            </p>
          </div>
        </div>
      </div>
    </header>
    <section class="section details">
      <div class="container py-4">
        <div
          class="columns is-mobile is-centered has-text-black-ter has-text-weight-medium"
        >
          <div class="column is-10">
            <div v-html="data.content"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { policyTerms } from "@/server/api.js";
import store from "@/store";

export default {
  components: {},
  computed: {
    config() {
      return store.state.global.configList || {};
    },
  },
  data() {
    return {
      data: {},
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    async getInfo() {
      try {
        const { status, data } = await policyTerms({});
        if (status == 0) {
          this.data = data;
        }
      } catch (error) {}
    },
  },
};
</script>
<style scoped>
.section {
  padding: 3rem 1.5rem;
}
.privacy-header {
  background-color: #f5d784;
  margin-top: 50px;
}
.container {
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}
.columns:last-child {
  margin-bottom: -1.5rem;
}
.has-text-centered {
  text-align: center !important;
}
.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
}
.title.is-1 {
  font-size: 3rem;
}
.title:not(.is-spaced) + .subtitle {
  margin-top: -1.25rem;
}

.has-text-weight-medium {
  font-weight: 500 !important;
}
.subtitle {
  color: #757763;
  font-family: Quicksand, sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
}
.title {
  color: #363636;
  font-family: Rubik, sans-serif;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
}
.tabs:not(:last-child),
.pagination:not(:last-child),
.message:not(:last-child),
.level:not(:last-child),
.breadcrumb:not(:last-child),
.block:not(:last-child),
.title:not(:last-child),
.subtitle:not(:last-child),
.table-container:not(:last-child),
.table:not(:last-child),
.progress:not(:last-child),
.notification:not(:last-child),
.content:not(:last-child),
.box:not(:last-child) {
  margin-bottom: 1.5rem;
}
.columns.is-mobile > .column.is-10 {
  flex: none;
  width: 83.33333337%;
}
.columns.is-centered {
  justify-content: center;
}
@media screen and (min-width: 769px), print {
  .columns:not(.is-desktop) {
    display: flex;
  }
  .column.is-full,
  .column.is-full-tablet {
    flex: none;
    width: 100%;
  }
  .column.is-10,
  .column.is-10-tablet {
    flex: none;
    width: 83.33333337%;
  }
}
@media screen and (min-width: 1024px) {
  .section {
    padding: 3rem;
  }
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1408px) {
  .container:not(.is-max-desktop):not(.is-max-widescreen) {
    max-width: 1344px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/policy/terms.vue